/**
 * DevExtreme (esm/ui/text_box/ui.text_editor.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import TextEditorMask from "./ui.text_editor.mask";
registerComponent("dxTextEditor", TextEditorMask);
export default TextEditorMask;
